<div
  class="flex w-full"
  appElementScreenSize
  [class.flex-col]="isResumeStyleOffer()"
>
  <div
    class="shrink-0 rounded-lg flex items-center justify-center"
    [class.p-3]="isResumeStyleOffer()"
    [class.bg-oat-800]="!isResumeStyleOffer()"
    [class.p-2]="!isResumeStyleOffer()"
  >
    <app-loan-card-image [offer]="offer()" />
  </div>

  <div class="p-3 w-full" [class.pt-1]="isResumeStyleOffer()">
    @if (offer()?.approvalBadge) {
      <div class="mb-2">
        <app-approval-chance
          [approval]="offer()?.approvalBadge"
          [disclosure]="offer()?.approvalDisclosure"
        ></app-approval-chance>
      </div>
    }
    <h3
      class="m-0"
      [class.heading-s]="isResumeStyleOffer()"
      [class.offer-title]="!isResumeStyleOffer()"
      [class.be-body-m-bold]="!isResumeStyleOffer()"
    >
      {{ offer().heading }}
      @if (showsMinAprInTitle()) {
        {{ offer().minApr | number: '1.2-2' }}%
      } @else if (
        offer()?.subProductType === 'SECURED_HOME_LOAN' && offer()?.minApr
      ) {
        {{ offer().minApr | number: '1.2-2' }}%
      } @else if (
        offer()?.subProductType === 'UNSECURED_LOAN' && offer()?.maxAmount
      ) {
        {{ offer().maxAmount | currency: 'USD' : 'symbol' : '1.0-0' }}
      }
    </h3>

    @if (isResumeStyleOffer() && offer()?.offerUrl) {
      <a
        [href]="offer().offerUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="get-offer-btn be-btn be-btn--small mt-4"
        (click)="clickResumeApplication()"
      >
        Resume application
      </a>
    } @else if (isSecuredLoanOffer()) {
      <button
        class="mb-2 be-btn--alt-link text-navy-700 p-0"
        [class.be-hint]="isContainerMobile()"
        [class.be-body-s-link]="!isContainerMobile()"
        (click)="onDisclosureClick()"
      >
        {{ offer()?.label }}
      </button>
    }
    @if (!isResumeStyleOffer()) {
      <div
        class="flex items-center mt-2"
        [class.mt-4]="offer().subProductType === 'UNSECURED_LOAN'"
        [class.gap-4]="isSecuredLoanOffer()"
        [class.justify-between]="!isSecuredLoanOffer()"
      >
        <a
          [href]="offer()?.offerUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="get-offer-btn be-btn be-btn--small be-btn--alt no-underline inline-flex items-center justify-center"
          (click)="onGetOffer()"
        >
          {{ offer().callToAction }}
        </a>
        @if (isSecuredLoanOffer()) {
          <button
            class="learn-more-btn be-btn be-btn--borderless text-navy-900 px-0"
            (click)="openSlideOut(offer())"
          >
            Learn more
          </button>
        } @else if (!isSecuredLoanOffer()) {
          <button
            class="be-btn--alt-link text-navy-700 p-0"
            [class.be-hint]="isContainerMobile()"
            [class.be-body-s-link]="!isContainerMobile()"
            (click)="onDisclosureClick()"
          >
            {{ offer()?.label }}
          </button>
        }
      </div>
    }
  </div>
</div>
